export default "__VITE_ASSET__BzQA39TD__ 584w";